import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import { Card, Grid, useMediaQuery } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hubAction } from "redux/slice/hub";

import "styles/hub.scss";
import ContentContainer from "./ContentContainer";
import Sidebar from "./Sidebar";

const Hub = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.loginUser.loginUserState);
  const isMobileDisplay = useMediaQuery((theme) => theme.breakpoints.only("xs"));
  const [queryString, setQueryString] = useState(null);
  const { content, notifications } = useSelector((state) => state.hub);
  const sidebarWidth = 80;
  const [isInialized, setIsInitialized] = useState(false);

  const channels = [
    {
      key: "win-wire",
      notificationKey: "winWire",
      displayName: "Win-Wire",
      icon: <EmojiEventsOutlinedIcon />,
      selectedColor: "#FFC438",
    },
    {
      key: "insights",
      notificationKey: "insights",
      displayName: "Insights",
      icon: <TipsAndUpdatesOutlinedIcon />,
      selectedColor: "#17B5F6",
    },
    {
      key: "reports",
      notificationKey: "reports",
      displayName: "Reports",
      icon: <SummarizeOutlinedIcon />,
      selectedColor: "#CA89F3",
    },
  ];

  const defaultChannelKey = "win-wire";
  const [selectedChannel, setSelectedChannel] = useState(null);

  useEffect(() => {
    if (isInialized) {
      dispatch(
        hubAction.getHubSaga({
          daysBack: 30,
          fromDate: moment.tz(user.timezone).endOf("day").utc().format("YYYY-MM-DD HH:mm:ss"),
          queryString,
        })
      );
    }
  }, [isInialized]);

  useEffect(() => {
    const parseHash = () => {
      const hash = window.location.hash.replace("#", "");
      const [path, query] = hash.split("?");
      return { path, query };
    };

    const { path, query } = parseHash();
    const channel =
      channels.find((c) => c.key === path) || channels.find((c) => c.key === defaultChannelKey);

    if (!path) {
      window.location.hash = defaultChannelKey;
    }

    setSelectedChannel(channel);
    setQueryString(query || null);

    setIsInitialized(true);
  }, []);

  const handleChannelClick = (channel) => {
    window.location.hash = channel.key;
    setSelectedChannel(channel);
  };

  const scrollToBottom = (bottomRef) => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Card className="hub-wrapper" sx={{ height: "100%" }}>
      <Grid
        container
        sx={{
          height: "100%",
          flexWrap: "nowrap",
          flexDirection: isMobileDisplay ? "column-reverse" : "row",
        }}
      >
        <Grid
          item
          sx={{
            width: isMobileDisplay ? "100%" : sidebarWidth,
            height: isMobileDisplay ? sidebarWidth : "100%",
          }}
        >
          <Sidebar
            channels={channels}
            selectedChannel={selectedChannel}
            handleChannelClick={handleChannelClick}
            notifications={notifications}
            isMobileDisplay={isMobileDisplay}
            sidebarWidth={sidebarWidth}
          />
        </Grid>
        <Grid item sx={{ flexGrow: 1 }}>
          <ContentContainer
            selectedChannel={selectedChannel}
            content={content}
            user={user}
            isMobileDisplay={isMobileDisplay}
            scrollToBottom={scrollToBottom}
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default Hub;
